import { useEffect, useState } from "react";
import { saasApi } from "../api/saasApi";

export function usePlans() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    saasApi
      .getPublicPlans()
      .then((res) => mounted && setPlans(res.data || []))
      .catch((err) => mounted && setError(err.message))
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  return { plans, loading, error };
}
